<template>
	<div class="media-tabs">
		<button
			class="media-tabs__btn"
			:class="{ 'media-tabs__btn--active': mediaType === 'all' }"
			@click="switchTab('all')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="currentColor"
				class="media-tabs__icon"
			>
				<path
					fill-rule="evenodd"
					d="M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Z"
					clip-rule="evenodd"
				/>
			</svg>
			<span>Wszystko</span>
		</button>
		<button
			class="media-tabs__btn"
			:class="{ 'media-tabs__btn--active': mediaType === 'image' }"
			@click="switchTab('image')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="currentColor"
				class="media-tabs__icon"
			>
				<path
					fill-rule="evenodd"
					d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
					clip-rule="evenodd"
				/>
			</svg>
			<span>Zdjęcia</span>
		</button>
		<button
			class="media-tabs__btn"
			:class="{ 'media-tabs__btn--active': mediaType === 'video' }"
			@click="switchTab('video')"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="currentColor"
				class="media-tabs__icon"
			>
				<path
					d="M4.5 4.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3H4.5ZM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06Z"
				/>
			</svg>
			<span>Filmy</span>
		</button>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	name: "MediaTabs",
	computed: {
		...mapState(["mediaType"]),
	},
	methods: {
		...mapActions(["setMediaType"]),
		switchTab(type) {
			if (this.mediaType !== type) {
				this.setMediaType(type);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";

.media-tabs {
	display: flex;
	justify-content: center;
	gap: 8px;
	margin-top: 24px;
	margin-bottom: 24px;
	padding: 8px;
	background: rgba(255, 255, 255, 0.95);
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	max-width: 500px;
	margin-left: auto;
	margin-right: auto;

	&__btn {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 20px;
		border: none;
		border-radius: 8px;
		background: transparent;
		color: $font_color;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.2s ease;
		flex: 1;
		justify-content: center;

		&:hover {
			background: rgba($blue, 0.08);
			color: $blue;
		}

		&--active {
			background: $blue;
			color: white;
			box-shadow: 0 2px 6px rgba($blue, 0.3);

			&:hover {
				background: darken($blue, 5%);
				color: white;
			}
		}
	}

	&__icon {
		width: 18px;
		height: 18px;
	}
}
</style>
